import { render, staticRenderFns } from "./loadingSpinner.vue?vue&type=template&id=253ac93e&scoped=true"
import script from "./loadingSpinner.vue?vue&type=script&lang=js"
export * from "./loadingSpinner.vue?vue&type=script&lang=js"
import style0 from "./loadingSpinner.vue?vue&type=style&index=0&id=253ac93e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253ac93e",
  null
  
)

export default component.exports